
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as agbt7PKGaEbR4Dj4rXPA44FVtDcgkgvVKBBUOhXKoPntt0Meta } from "/app/pages/agb.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as imprinthkouq5hSidrpTSuflE7DpDLLzD4EE_45s4nlZ8qXwh8sIMeta } from "/app/pages/imprint.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as _91id_93oiqsxZgUdH7iKcXKulHI_9hGzJkDE_45CwADyGT5tEQZwMeta } from "/app/pages/works/[id].vue?macro=true";
import { default as indexjRXR8_C0my_45KLI9kHuU2TChvALXrlmjz4rFBYDneAMYMeta } from "/app/pages/works/index.vue?macro=true";
import { default as _91id_93uQdzhQjQ5hfoh1b5V73marJk_Qqw8xQfCP_J1CXhj0QMeta } from "/app/pages/applications/[id].vue?macro=true";
import { default as component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8Meta } from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.0.8_@vue+compiler-sfc@3.5.26_cac@6.7.1_ca18fcc40b094d04ab0d3300b203aa31/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8 } from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.0.8_@vue+compiler-sfc@3.5.26_cac@6.7.1_ca18fcc40b094d04ab0d3300b203aa31/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "agb___de",
    path: "/agb",
    component: () => import("/app/pages/agb.vue")
  },
  {
    name: "agb___en",
    path: "/en/agb",
    component: () => import("/app/pages/agb.vue")
  },
  {
    name: "index___de",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "imprint___de",
    path: "/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "imprint___en",
    path: "/en/imprint",
    component: () => import("/app/pages/imprint.vue")
  },
  {
    name: "profile___de",
    path: "/profile",
    meta: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta || {},
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta || {},
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "works-id___de",
    path: "/works/:id()",
    component: () => import("/app/pages/works/[id].vue")
  },
  {
    name: "works-id___en",
    path: "/en/works/:id()",
    component: () => import("/app/pages/works/[id].vue")
  },
  {
    name: "works___de",
    path: "/works",
    meta: indexjRXR8_C0my_45KLI9kHuU2TChvALXrlmjz4rFBYDneAMYMeta || {},
    component: () => import("/app/pages/works/index.vue")
  },
  {
    name: "works___en",
    path: "/en/works",
    meta: indexjRXR8_C0my_45KLI9kHuU2TChvALXrlmjz4rFBYDneAMYMeta || {},
    component: () => import("/app/pages/works/index.vue")
  },
  {
    name: "applications-id___de",
    path: "/applications/:id()",
    meta: _91id_93uQdzhQjQ5hfoh1b5V73marJk_Qqw8xQfCP_J1CXhj0QMeta || {},
    component: () => import("/app/pages/applications/[id].vue")
  },
  {
    name: "applications-id___en",
    path: "/en/applications/:id()",
    meta: _91id_93uQdzhQjQ5hfoh1b5V73marJk_Qqw8xQfCP_J1CXhj0QMeta || {},
    component: () => import("/app/pages/applications/[id].vue")
  },
  {
    name: component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8
  },
  {
    name: component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8Meta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubL6qXSymmY3RRHcC99IFcRg_45sge7WqpgfAMe9Rv_45cvd8
  }
]